import graphql from "babel-plugin-relay/macro";

export const FREE_CALENDAR_WEEKS_FRAGMENT = graphql`
	fragment exceptionModal_FreeCalenderWeeksFragment on CalendarWeekAndYear @relay(plural: true) {
		calendarWeek
		calendarYear
	}
`;
